/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateMediaExportJobsMutationRequest, CreateMediaExportJobsMutationResponse } from "../models/CreateMediaExportJobs";

export function getCreateMediaExportJobsUrl() {
  const res = { method: 'POST', url: `/export-jobs` as const }
  return res
}

/**
 * @description Adds an export media job for the current user. Returns the job (id, status, progress, etc.).
 * @summary Enqueue export job
 * {@link /export-jobs}
 */
export async function createMediaExportJobs(data: CreateMediaExportJobsMutationRequest, config: Partial<RequestConfig<CreateMediaExportJobsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateMediaExportJobsMutationResponse, ResponseErrorConfig<Error>, CreateMediaExportJobsMutationRequest>({ method : "POST", url : getCreateMediaExportJobsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}